// Import necessary modules
import { React, useEffect, useState } from 'react';
import { Grommet, Card, Heading, Header, CardHeader, Anchor, CardBody, CardFooter, Box, Text, Button, Image, Tab, Tabs } from 'grommet';
import { hpe } from 'grommet-theme-hpe';
import ReleaseSummary from '../custom-page/ReadMoreReadLess.js';
import { Bold } from 'grommet-icons';
import CATab from '../custom-page/CA.js';
import { useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import LicenseAgreementComponent from '../licenseagreement-page/LicenseAgreementComponent.js';
import SPPComponent from '../spp-page/SPPComponent.js';
import PropTypes from 'prop-types';
import { useLocation,useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


function convertHtmlToText(html) {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  const anchors = tempDiv.getElementsByTagName('a');
  for (let anchor of anchors) {
    const text = anchor.textContent;
    const href = anchor.href;
    const color = anchor.style.color || '#01A982';
    const replacement = `${text} (Link: ${href}, Color: ${color})`;
    anchor.replaceWith(document.createTextNode(replacement));
  }

  const textContent = tempDiv.innerText || tempDiv.textContent;
  return textContent.trim();
}

const PatchComponent = ({ }) => {
  const { t } = useTranslation(); 
  const navigate = useNavigate();
  const [showSPPComponent, setShowSPPComponent] = useState(false);
  
  const location = useLocation(); // Get the current location (URL)

  // Function to extract query parameters
  const getQueryParams = (param) => {
    const searchParams = new URLSearchParams(location.search); // Parse the query string
    return searchParams.get(param); // Return the value of the passed parameter (e.g., 'version')
  };

  const patchVersion = getQueryParams('version'); // Get the 'version' parameter from the URL

  const handleBaseSPPClick = (item) => {
    //setShowSPPComponent(true);
    //setVersion(item);
    //<SPPComponent version={item}> </SPPComponent>
    navigate(`/index.aspx?version=${item}`);
  };
  const { patchVersion: versionParam } = useParams();
  
  useEffect(() => {
    if (versionParam && versionParam !== patchVersion) {
      console.log('Version from URL:', versionParam);
    }
  }, [versionParam, patchVersion]);
  console.log('patchversionpassed', patchVersion);
  const [version, setVersion] = useState(null);
  const [showLicense, setShowLicense] = useState(false);
  const [patchInfo, setData] = useState(null);
  const [sppType, setType] = useState(null);
  const [patchType, setpatchType] = useState(null);
  const [ResolvedCAData, setResolvedCA] = useState(null);
  const [OpenCAData, setOpenCA] = useState(null);

  //const [sppdata, setSPPInfo] = useState(null);
  //const patchVersion = "gen11" + ".2024.04.00.01";
  //const fileName = './assets/' + patchVersion + '.json';
  const basePath = window.location.origin;
  const pathName = window.location.pathname;
  let fileName = `${basePath}${pathName}assets/${patchVersion}.json`; 
  console.log('patchfilename', fileName);

  useEffect(() => {
    fetch(fileName)
      .then(response => response.json())
      .then(data => {
        setData(data);
        setOpenCA(data.Advisories.OpendCAs);
        setResolvedCA(data.Advisories.ResolvedCAs);
        const octetCount = (patchVersion.match(/\./g) || []).length;
        if (octetCount == 4) {
          setType("Base SPP");
          setpatchType("Patch");
        }
        else {
          setType("Base SPP");
          setpatchType("Hotfix & Supplements");
        }
      })
      .catch(error => console.error('Error fetching json data:', error));
  }, [fileName]); // Dependency array includes fileName to refetch if fileName changes

  console.log('shr2', patchInfo);
  const patchTitle = t('PatchOverview');
  const patchDescription = "This is a description or summary for the card content. It provides a brief overview of the content or purpose of the card. This content can be dynamic and passed as props to the GrommetCard component.";

  let patchReleaseSummary = '';//convertHtmlToText("<p>Gen11 SPP 2024.04.00.00 includes support for the following OS Versions:</p>\r\n\r\n<ul>\r\n\t<li>Red Hat Enterprise Linux 8.9</li>\r\n\t<li>Red Hat Enterprise Linux 9.3</li>\r\n</ul>\r\n\r\n<p>&nbsp;</p>\r\n\r\n<p>It also includes support for Alletra 4140 Server with 5th Gen Intel® Xeon® Scalable Processors and Gen11 MicroServer platforms.</p>\r\n\r\n<p>&nbsp;</p>\r\n");

  if (patchInfo) {
    patchReleaseSummary = patchInfo.PatchDescription
      ? parse(patchInfo.PatchDescription)
      : "Release Summary not available";
  }

  const ReleaseTitle = t('ReleaseSummary');



  const patchReleaseDate = "2024-04-19";

  const formattedDate = patchInfo?.ReleaseDate 
  ? new Date(patchInfo.ReleaseDate).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
  : '';




  const onLicenseLinkClick = (link) => {

    if (link.includes('/licenseagreements')) {
      navigate(`/spp/licenseagreements`);
    }
  };

  const GrommetCard = ({ title, description, patchInfo }) => (
    // <Box margin={{ left: 'small' }}>
      <Card
        width="850px"
        height="350px"
        background="light-1"
        round="small"
        elevation="medium"
      >
        {/* <CardHeader pad="medium">
          <Text size="large" weight="bold">{title}</Text>
        </CardHeader> */}
        <Header margin={{left:'xsmall'}}>
          <Heading weight="bold" level={3}>
            {title}
          </Heading>
        </Header>
        <CardBody pad='None' gap='None' overflow="auto">

          {patchInfo &&
            
              <Box direction="column" align="start" pad='None' gap="small"> {/* Increase the gap between the columns */}
                <Box direction="row" align="start" gap="small"> {/* Increase the gap within the row */}
                  <Box direction="column" align="start" gap="small">
                    <Text weight="bold">
                      {t('Type')}
                    </Text>
                    <Text>
                      {patchType}
                    </Text>
                  </Box>
                  <Box direction="column" align="start" gap="small">
                    <Text weight="bold">
                     {t('ReleaseDate')}
                    </Text>
                    <Text>
                      {formattedDate}
                    </Text>
                  </Box>
                  <Box direction="column" align="start" gap="small">
                    <Text weight="bold">
                      {t('BaseSPP')}
                    </Text>
                    <Anchor href={patchInfo.baseSPP.Link} onClick={()=>handleBaseSPPClick(patchInfo.Generation.toLowerCase() + '.' + patchInfo.baseSPP.Name)} label={
                      <Text>
                        {patchInfo.baseSPP.Name}
                      </Text>
                    } />
                  </Box>
                </Box>






                <Box direction="row" align="start" gap="medium" > {/* Add margin to further separate the rows */}
                  <Box direction='column' align="start" gap="medium">
                    <Button
                      label={t('DownloadPatchBundle')}
                      onClick={() => window.open(patchInfo.PatchDownloadLink, '_blank')}
                      primary
                    />
                  </Box>
                  <Box direction='column' align="start" gap="small">
                    {/* <Text color="brand">
                      <Anchor href={patchInfo.License} onClick={()=>onLicenseLinkClick(patchInfo.License)} label="License Agreement" />
                    </Text> */}
                  </Box>
                </Box>


                <Box margin={{left:'xsmall'}} direction="row" gap="medium">
                  <Box direction="column" gap="medium">
                    <Button
                      label={t('CreateanSPPCustomDownload')}
                      onClick={() => window.open("https://spp.hpe.com/custom/#/sources/YnAwMDY4MTAuMTcxMzQ4NDgwMA", '_blank')}
                      secondary
                      style={{ whiteSpace: 'nowrap' }} // Prevent text from wrapping
                    />

                  </Box>
                  <Box margin={{left:'xsmall'}} direction="column" gap="xsmall">
                   {/* <Text  style={{ whiteSpace: 'normal' }}>
                      {t('CustomSPPLinkDescription')} 
                    </Text> */}
                  </Box>
                </Box>
                 <Box margin={{left:'xsmall'}} direction="row" gap="medium">
                  
                  <Box margin={{left:'xsmall'}} direction="column" gap="xsmall">
                    <Text  style={{ whiteSpace: 'normal' }}>
                      {t('CustomSPPLinkDescription')} 
                    </Text> 
                  </Box>
                </Box>



                <Box margin={{ left: 'xsmall' }} direction="row" gap="small">


                  <Box pad={{left:'xmsmall'}} direction="column" gap="small">
                    <Anchor href={patchInfo.ContentsList} label={
                      <Text >
                        {t('ContentList')}
                      </Text>
                    } />
                  </Box>
                </Box>
                <Box margin={{ left: 'xsmall' }} direction="row" gap="small">
                  <Box direction="column" gap="small">
                    <Anchor href={patchInfo.ReleaseNotes} label={
                      <Text >
                       {t('ReleaseNotes')}
                      </Text>
                    } />

                  </Box>


                </Box>
              </Box>

            }
        </CardBody>

      </Card>
    // </Box>
  );


  return (
    <Grommet themeMode="light" theme={hpe}>
      <>
        {/* {showSPPComponent ? (
          <SPPComponent version={version}  />
        ) : ( */}
        <Box direction='column' gap="small">
          <Box direction='row' gap="small">
            {/* Page Title */}
            {patchInfo && patchInfo.PatchName && patchInfo.BundleVersion && (
              <Box margin={{ left: 'small', bottom: 'small' }}>
                {/* <Text size="xlarge" weight="bold">
                {patchInfo.PatchName + " Version " + patchInfo.BundleVersion}
              </Text> */}
                <Header >
                  <Heading weight="bold" level={1}>
                    {patchInfo.PatchName + " Version " + patchInfo.BundleVersion}
                  </Heading>
                </Header>
              </Box>
            )}
          </Box>

          <Box direction="row" gap="small">
            <Box direction="column" >
              <GrommetCard title={patchTitle} patchInfo={patchInfo} />
            </Box>
            <Box direction="column" >
              <ReleaseSummary text={patchReleaseSummary} title={ReleaseTitle} summaryheight={"350px"}></ReleaseSummary>
            </Box>

          </Box>
          <Box  direction="row" gap="small">
            <Box direction="column" gap="small">
              <Box  direction="row" gap="small" >
                <Tabs justify='start'>

                  <Tab background="light-2" title={t('ResolvedCAs')}>
                    <CATab CAdata={ResolvedCAData} align="start"></CATab>
                  </Tab>
                  <Tab background="light-2" align="start" title={t('OpenCAs')}>
                    <CATab CAdata={OpenCAData} align="start"></CATab>
                  </Tab>
                </Tabs>
              </Box>
            </Box>
          </Box>
        </Box>
        {/* )} */}
      </>
    </Grommet>
  );
};

PatchComponent.propTypes = {
  setVersion: PropTypes.func,
};


export default PatchComponent;
